import * as accountActions from './accounts'
import * as config from './config'
import * as administratorTypeActions from './administratorTypes'
import * as currentAccountActions from './currentAccount'
import * as patientActions from './patients'
import * as currentPatientActions from './currentAccount'
import * as appointmentActions from './appointments'
import * as appointmentTypeActions from './appointmentTypes'
import * as sessionActions from './sessions'
import * as genderActions from './genders'
import * as classificationActions from './classifications'
import * as breedActions from './breeds'
import * as administratorActions from './administrators'
import * as shiftActions from './shifts'
import * as openTimeActions from './openTimes'
import * as serviceTimeActions from './serviceTimes'
import * as integrationConfigActions from './integrationConfigs'
import * as organizationActions from './organizations'
import * as availabilityActions from './availabilities'
import * as restrictionActions from './restrictions'
import * as workersActions from './workers'
import * as messageActions from './messages'
import * as notificationActions from './notifications'
import * as serviceRegionActions from './serviceRegions'
import * as serviceAreaActions from './serviceAreas'
import * as messengerTemplatesActions from './messengerTemplates'
import * as syncActions from './sync'
import * as syncStatusActions from './syncStatus'
import * as waitingRoomActions from './waitingRoom'
import * as customFieldActions from './customFields'
import * as waitListActions from './waitLists'
import * as waitListMessageActions from './waitListMessages'
import * as insightsActions from './insights'

export {
    accountActions,
    administratorTypeActions,
    config,
    messageActions,
    insightsActions,
    notificationActions,
    currentAccountActions,
    patientActions,
    currentPatientActions,
    appointmentActions,
    appointmentTypeActions,
    sessionActions,
    genderActions,
    classificationActions,
    breedActions,
    administratorActions,
    shiftActions,
    openTimeActions,
    serviceTimeActions,
    integrationConfigActions,
    organizationActions,
    availabilityActions,
    restrictionActions,
    workersActions,
    serviceRegionActions,
    serviceAreaActions,
    messengerTemplatesActions,
    syncActions,
    syncStatusActions,
    waitingRoomActions,
    waitListActions,
    waitListMessageActions,
    customFieldActions
}


// WEBPACK FOOTER //
// ./src/actions/index.js